import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  loaded: false,
  loadingResources: false,
  loadingResource: false,
  selected: null,
  ppe: [],
  decontamination: [],
  detector: [],
  sampling_type: [],
  materialPortalResource: {},
  error: null,
}

export default {
  state,
  actions,
  getters,
  mutations
}
